import { produce } from 'immer'
import { OrganizationIntegrationListResponse } from 'src/models/organizationIntegration.models'
import { orgIntegrationsRouteProps } from 'src/navigation/routeProps'
import {
  GET_ORG_INTEGRATIONS_FAILURE,
  GET_ORG_INTEGRATIONS_INIT,
  GET_ORG_INTEGRATIONS_SUCCESS,
  GetOrgIntegrationsActions,
} from 'src/queries/organizations/integrations/integrations.actions'
import {
  GET_ORGANIZATION_INTEGRATIONS_FAILURE,
  GET_ORGANIZATION_INTEGRATIONS_INIT,
  GET_ORGANIZATION_INTEGRATIONS_SUCCESS,
  GetOrganizationIntegrationsActions,
} from 'src/redux/actions/data/organizations.actions'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import { parseBackendErrors } from 'src/utils/error.utils'

export interface OrgIntegrationState {
  orgIntegration?: OrganizationIntegrationListResponse
  loadingOrgIntegrations: boolean
  topLevelError?: string
}

export const initialState: OrgIntegrationState = {
  loadingOrgIntegrations: false,
  topLevelError: undefined,
}

export type Actions =
  | GetOrgIntegrationsActions
  | GetOrganizationIntegrationsActions

const CoreOrgIntegrationReducer = (
  state = initialState,
  action: Actions,
): OrgIntegrationState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_ORGANIZATION_INTEGRATIONS_INIT:
      case GET_ORG_INTEGRATIONS_INIT: {
        draft.loadingOrgIntegrations = true
        draft.topLevelError = undefined
        return draft
      }
      case GET_ORGANIZATION_INTEGRATIONS_SUCCESS:
      case GET_ORG_INTEGRATIONS_SUCCESS: {
        draft.loadingOrgIntegrations = false
        return draft
      }
      case GET_ORGANIZATION_INTEGRATIONS_FAILURE:
      case GET_ORG_INTEGRATIONS_FAILURE: {
        const { topLevelError } = parseBackendErrors(action.payload)

        draft.loadingOrgIntegrations = false
        draft.topLevelError = topLevelError
        return draft
      }
    }
  })
}

const OrgIntegrationReducer = createBackgroundReducer(
  orgIntegrationsRouteProps,
  initialState,
  CoreOrgIntegrationReducer,
)

export default OrgIntegrationReducer
